import { Typography } from "antd";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { badge } from "../shared/statusCodeColors";

const { Text } = Typography;
export const TransactionHash = ({ data, handleHash }) => {
    return (
        <td onClick={handleHash(data)} >
            {data?.transactionhash && <Text
                copyable={{ text: data?.transactionhash, tooltips: ['Copy', 'Copied'] }}
                className="text-gray-900 dark:text-white text-base truncate max-w-[60%] text-right"
            >
                <span className=' text-link cursor-pointer'>{data?.transactionhash ? `${data?.transactionhash?.slice(0, 8)}.....${data?.transactionhash?.slice(-8)}` : data?.transactionhash}</span>
            </Text>}
        </td>)
}
export const AddresssHandler = ({ data }) => {
    return (
        <td className=''>
            {data?.address && <Text
                copyable={{ text: data?.address, tooltips: ['Copy', 'Copied'] }}
                className="text-gray-900 text-white text-base truncate max-w-[60%] text-right"
            >
                {data?.address ? `${data?.address?.slice(0, 8)}.....${data?.address?.slice(-8)}` : data?.address}
            </Text>}
        </td>)
}
export const CreditHandler = ({ data }) => {
    return (
        <td className=''>
            <NumericFormat value={data?.credits} displayType={'text'} thousandSeparator={true}></NumericFormat>
        </td>)
}
export const DateHandler = ({ data }) => {
    return (
        <td>
            <div>
                {data?.date ? <> {moment.utc(data?.date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.date}
            </div>
        </td>
    )
}
export const AmountHandler = ({ data }) => {
    return (
        <td>
            <NumericFormat value={data?.amount} displayType={'text'} thousandSeparator={true}></NumericFormat>
        </td>)
}
export const StatusHandler = ({ data }) => {
    return (
        <td>
            <span className={`status-badge ${badge[data?.status?.toLowerCase()] || 'bg-green'}`}>{data?.status}</span>
        </td>
    )
}